import {
  createStyles,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  MenuItemProps,
  MenuProps,
  Theme,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import classnames from 'classnames';
import React, { Fragment } from 'react';

export type MenuOptionItem = {
  onClick: (id: string) => void;
  label: React.ReactNode;
};

export function MoreOptionsMenu({
  id,
  options,
  Button = IconButton,
  menuProps,
  menuItemProps,
  className,
  ...other
}: {
  [x: string]: unknown;
  id: string;
  className?: string;
  options: Array<MenuOptionItem | null>;
  Button?: React.ComponentType<{
    [x: string]: unknown;
    onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    children: React.ReactNode;
  }>;
  menuProps?: Partial<MenuProps>;
  // Explicity 'li' needed due to https://github.com/mui-org/material-ui/issues/16245
  menuItemProps?: Partial<MenuItemProps<'li', { button?: true }>>;
  // other button props
}): React.ReactElement {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Button {...other} onClick={handleClick} className={classnames(className, classes.moreIconButton)}>
        <MoreVertIcon />
      </Button>

      <Menu
        {...menuProps}
        anchorEl={anchorEl}
        open={anchorEl != null}
        onClose={handleClose}
        closeAfterTransition
        getContentAnchorEl={null}
        disableScrollLock={true}
      >
        {options
          .filter((item) => !!item)
          .map((option, index) => {
            return (
              option && (
                <MenuItem
                  {...menuItemProps}
                  key={`key_${index}`}
                  onClick={(): void => {
                    handleClose();
                    option?.onClick(id);
                  }}
                >
                  {option?.label}
                </MenuItem>
              )
            );
          })}
      </Menu>
    </Fragment>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    moreIconButton: {
      display: 'flex',
      minWidth: 32,
    },
  })
);
